import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    throwError as observableThrowError,
    Observable,
    BehaviorSubject,
    throwError,
} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Response } from '@angular/http';
@Injectable({
    providedIn: 'root',
})
export class OnboardingService {
    constructor(
        private http: HttpClient,
        @Inject('baseUrl') private baseUrl: string
    ) {}

    //fetch all questions by category
    question(category: string) {
        return this.http
            .get(this.baseUrl + `/suitability?category=` + category)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    capacityQuestion() {
        return this.http
            .get(this.baseUrl + `/suitability?category=CAPACITY`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    submitResponse(questionId: number, optionId) {
        const data = {
            id: questionId,
            optionId: optionId,
        };

        return this.http
            .post(this.baseUrl + `/suitability/response`, data)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getNextQuestion() {
        return this.http
            .get(this.baseUrl + `/suitability/question/next`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    getResponse() {
        return this.http
            .get(this.baseUrl + `/suitability/response/user`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    riskProfile() {
        return this.http
            .get(this.baseUrl + `/suitability/response/result`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    fetchSujects() {
        return this.http
            .get(this.baseUrl + `/suitability/subject`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    fetchPreviousQuestion() {
        return this.http
            .get(this.baseUrl + `/suitability/question/before`)
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    previousQuestion(Id: number, category: string) {
        return this.http
            .get(
                this.baseUrl +
                    `/suitability/question/previous?Id=` +
                    Id +
                    `&category=` +
                    category
            )
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

    fetchResponseByQuestionId(questionId) {
        return this.http
            .get(
                this.baseUrl + `/suitability/responses?questionId=` + questionId
            )
            .pipe(
              catchError(err => {
                  return throwError(err);
              })
          )
    }

}
